export class CustomHelpers {
    constructor(config) {
        if (!config.scene) {
            console.log("missing scene!");
            return;
        }

        this.scene = config.scene;
    }

    applyDynamicFontSize(text, width) {
        if(typeof text.originalFontSize === 'undefined') {
            text.originalFontSize = text.style.fontSize;
        }

        text.setFontSize(text.originalFontSize, text.displayWidth);

        if(width < text.displayWidth) {
            const ratio = text.displayWidth / width;
            let size = Math.ceil(text.style.fontSize.replace('px', '') / ratio);
            text.setFontSize(`${size}px`);
        }
    }

    applyDynamicSpriteSize(sprite, width) {
        sprite.setScale(1);
        let currentWidth = sprite.displayWidth;

        if (currentWidth === undefined) {
            currentWidth = sprite.width
        }

        if (width < currentWidth) {
            const scale = (width / currentWidth);
            sprite.setScale(scale);
        }
    }

    createWinningFromSprites(number, scale, skin, customOffsetX) {
        let amountSymbolsCount = String(number).trim();
        let container = this.scene.add.container();
        let amount;
        let items = [];
        let offsetX = 0;

        if(customOffsetX) {
            offsetX = customOffsetX;
        }

        for (let i = 0; i < amountSymbolsCount.length; i++) {
            let spriteName = `counter_${amountSymbolsCount[i]}`;
            let separator = false;
            let anchorY = 0.5;

            switch(amountSymbolsCount[i]) {
                case '.':
                    spriteName = 'counter_dot';
                    separator = true;
                    anchorY = 1;
                    break;
                case ',':
                    spriteName = 'counter_comma';
                    separator = true;
                    anchorY = 1;
                    break;
                case '-':
                    spriteName = 'counter_minus';
                    break;
            }

            if(skin) {
                spriteName += skin;
            }

            amount = this.scene.add.sprite(0, 0, spriteName).setOrigin(0.5, anchorY);
            amount.setScale(scale);

            if (amountSymbolsCount[i] == ' ') {
                amount.alpha = 0;
            }

            if(i > 0) {
                amount.x = (prevAmount.x + prevAmount.displayWidth / 2 + amount.displayWidth / 2) + offsetX;
            }

            if(separator) {
                amount.y = prevAmount.y
                if(![',','.'].includes(preSymbol)) {
                    amount.y = prevAmount.y + prevAmount.displayHeight / 2;
                }
            }

            container.add(amount);

            let prevAmount = amount;
            let preSymbol = amountSymbolsCount[i];
            items.push(amount);
        }

        let minusOffsetX = amount.x / 2;
        let minusOffsetY = amount.y / 2;

        items.forEach((value) => {
            value.x -= minusOffsetX;
            value.y -= minusOffsetY;
        });

        let width = (items[items.length-1].x + items[items.length-1].width / 2) - (items[0].x - items[0].width / 2)

        container.setSize(width, amount.height);

        return container;
    }

    removeClickable(item, callback) {
        item.disableInteractive();
        item.removeListener('pointerup');
        item.removeListener('pointerover');
        item.removeListener('pointerout');

        if (callback) {
            callback();
        }
    }
}